"use client";
import { useCallback, useEffect, useRef } from "react";
import { useDebouncedCallback } from "use-debounce";
function useVisualViewportHeightVar(active) {
    const elementRef = useRef(null);
    const applyHeight = useCallback(()=>{
        const viewport = window.visualViewport;
        const element = elementRef.current;
        if (!viewport || !element) return;
        element.style.setProperty('--vvh', `${viewport.height}px`);
    }, []);
    const onResize = useDebouncedCallback(applyHeight, 300);
    const setRef = useCallback((node)=>{
        elementRef.current = node;
        if (node && window.visualViewport) node.style.setProperty('--vvh', `${window.visualViewport.height}px`);
    }, []);
    useEffect(()=>{
        if (!active) return;
        const viewport = window.visualViewport;
        if (!viewport) return;
        applyHeight();
        viewport.addEventListener('resize', onResize);
        return ()=>{
            viewport.removeEventListener('resize', onResize);
            onResize.cancel();
            elementRef.current?.style.removeProperty('--vvh');
        };
    }, [
        active,
        applyHeight,
        onResize
    ]);
    return setRef;
}
export { useVisualViewportHeightVar };
